import { Bedbank } from '@luxuryescapes/contract-svc-bedbank/types/bedbank';

import { ReservationSource } from '~/hooks/apis/reservations/reservationQueryKeys';

export { ReservationSource };

/**
 * Action names for reservation remediation jobs.
 * TODO: Move this enum to @luxuryescapes/contract-svc-reservation
 * to share with svc-reservation and other consumers.
 */
export enum ReservationActionName {
  Commit = 'commit',
  Cancel = 'cancel',
  Modify = 'modify',
  Abandon = 'abandon',
}

export interface AccommodationItem {
  reservation: {
    id: string;
    channel_manager: string;
    check_in?: string;
    check_out?: string;
    [key: string]: unknown;
  };
  status?: string;
  [key: string]: unknown;
}

export interface ChannelManagerResponse {
  status?: string;
  original_response?: string;
  createdAt?: string;
  [key: string]: unknown;
}

export interface BedbankReservationLog {
  id: string;
  functionName: string;
  status: 'success' | 'error';
  createdAt: string;
  originalRequest?: {
    type: string;
    url: string;
    data?: unknown;
    [key: string]: unknown;
  };
  originalResponse?: {
    name?: string;
    message?: string;
    _status?: number;
    _body?: {
      error?: {
        code?: string;
        message?: string;
      };
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
}

export interface ReservationFailureItem {
  reservationId: string;
  actionName: ReservationActionName;
  channelManager?: string;
  source?: ReservationSource;
  queueName?: string;
  jobId?: string | number;
  finishedOn?: number;
  accommodationItem?: AccommodationItem;
  bookingNumber?: string;
  bedbankLogs?: Array<BedbankReservationLog>;
  requests?: Array<unknown>;
  responses?: Array<ChannelManagerResponse>;
  resolved?: boolean;
  error?: string;
  order?: {
    id?: string;
    status?: string;
    customer_full_name?: string;
    accommodation_items: Array<AccommodationItem>;
    [key: string]: unknown;
  };
  supplier?: string;
  propertyId?: string;
  roomId?: string;
  occupancy?: Array<string>;
  checkIn?: string;
  checkOut?: string;
  status?: Bedbank.Reservation['state'];
  failedReason?: string;
  attemptsMade?: number;
  maxAttempts?: number;
  jobTimestamp?: number;
  [key: string]: unknown;
}

export interface ConfirmationFields {
  posted: string;
  confirmationInput: string;
}

export interface ClearFailedJobParams {
  channelManager: string;
  reservationId: string;
  actionName: ReservationActionName;
  resolution: string;
  source?: ReservationSource;
  queueName?: string;
  jobId?: string | number;
}
